import Control from './control';

export default class ControlScene {
  controls: Control[];

  constructor() {
    this.controls = new Array<Control>();
  }
}
